import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  constructor(private _http: HttpClient) {}

  getStripeData() {
    return this._http.get(
      'http://localhost:4053/api/FinanceStripe/GetTransactionStripeDataByPage?pageNumber=1&pageSize=20&columnName=Id',
    );
  }
}
